import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function UnitsMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { unitList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingUS, setIsLoadingUS] = useState(false);
  const [showUnit, setShowUnit] = useState(false);
  const [isUnitUnique, setIsUnitUnique] = useState(true);
  const [buttonDownUnit, setButtonDownUnit] = useState(true);
  const [umBtnDisable, setUmBtnDisable] = useState(false);
  const [addingUnits, setAddingUnits] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isUM, setIsUM] = useState(false);
  const [unitData, setUnitData] = useState([]);
  const [isUniqUnitId, setIsUniqUnitId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'units', 'addEdit');

  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'units', 'delete');
  useEffect(() => {
    setUnitData(unitList);
    if (addingUnits) {
      setUnitData([
        ...unitList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [unitList, addingUnits]);

  const callApi = async () => {
    setButtonDownUnit(!buttonDownUnit);
    setIsLoadingUS(true);
    buttonDownUnit ? setShowUnit(true) : setShowUnit(false);
    const unitsParams = {
      loggedInUserId,
    };
    isEmpty(unitData) && (await dispatch(action.getAllUnitDetails(unitsParams)));
    setIsLoadingUS(false);
  };

  const handleChanged = (event, i) => {
    const uni = [...unitData];

    if (event.target.value.length <= 30) {
      setIsUnitUnique(true);
      setIsUniqUnitId([]);
      uni[i] = {
        ...uni[i],
        name: event.target.value,
        isEmpty: event.target.value === '',
      };
      const arr = [];
      const arrIndex = [];
      uni.forEach((ele, ind) => {
        uni.forEach((objs, index) => {
          if (ele.name === objs.name && ind !== index) {
            arr.push(ele);
            arrIndex.push(index);
          }
        });
      });
      if (!isEmpty(arr)) {
        const arrs = [...arrIndex];
        const removeArss = Math.min(...arrs);
        const newArr = arrIndex.filter((ele) => ele !== removeArss);
        setIsUniqUnitId([...newArr]);
      }
      setIsUnitUnique(isEmpty(arr));
      let disableUT = false;
      uni.forEach((unitElement) => {
        if (isEmpty(unitElement?.name?.trim())) {
          disableUT = true;
        }
      });
      setUmBtnDisable(disableUT);
      setUnitData(uni);
    }
  };

  const addUnits = async () => {
    if (!showUnit) {
      setAddingUnits(true);
      setButtonDownUnit(!buttonDownUnit);
      setIsLoadingUS(true);
      buttonDownUnit ? setShowUnit(true) : setShowUnit(false);
      const unitsParams = {
        loggedInUserId,
      };
      isEmpty(unitData) && (await dispatch(action.getAllUnitDetails(unitsParams)));
      setIsLoadingUS(false);
    } else if (!isEmpty(unitData)) {
      setUnitData([...unitData, tempObj]);
    } else {
      setUnitData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      unitData.splice(id, 1);
      unitData.forEach((unitElement) => {
        if (isEmpty(unitElement?.name?.trim()) && unitElement.isNew) {
          setUmBtnDisable(true);
        } else {
          setUmBtnDisable(false);
        }
      });
      setIsUnitUnique(true);
      setIsUniqUnitId([]);
      setUnitData([...unitData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveUnits = async () => {
    setIsUM(true);
    if (!isEmpty(unitData)) {
      const emptyField = await unitData.filter((usitem) => usitem.name === null || usitem.name === '');
      if (isEmpty(emptyField)) {
        const data = unitData.map((usobj) => {
          return { ...usobj, name: usobj?.name?.trim() };
        });
        const unitsSaveParams = {
          title: t('UNITS_MASTER.UNITS'),
          loggedInUserId,
          names: JSON.stringify(data),
        };

        setAddingUnits(false);
        await dispatch(action.saveToSystemMaster(unitsSaveParams, t));
        const unitsParams = {
          loggedInUserId,
        };
        await dispatch(action.getAllUnitDetails(unitsParams));
        // post API
      } else {
        const newState = unitData.map((uobj) => (uobj?.isEmpty === false && uobj.name === null ? { ...uobj, isEmpty: true } : uobj));
        setUnitData(newState);
      }
    }
    setIsUM(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    unitData.forEach((ele, index) => {
      unitData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsUnitUnique(isEmpty(array));
      setIsUniqUnitId([]);
    }
  }, [unitData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const unitsDeleteParams = {
      loggedInUserId,
      unitId: deleteId,
      title: t('UNITS_MASTER.UNIT'),
    };
    await dispatch(action.deleteFromSystemMasters(unitsDeleteParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setUnitData([...unitList]);
    const unitsParams = {
      loggedInUserId,
    };
    await dispatch(action.getAllUnitDetails(unitsParams));
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let uts = {};
    unitData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: t('UNITS_MASTER.UNIT'),
        };
        uts = data;
      }
    });
    const res = await dispatch(action.setActiveInactive(uts, t));
    if (res?.code === 400) {
      unitData.forEach((ele) => {
        if (ele._id === activeInactiveID) {
          ele.isActive = true;
          const data = {
            ...ele,
            loggedInUserId,
            title: t('UNITS_MASTER.INPUT_NAME'),
          };
          uts = data;
        }
      });
      setIsLoadingConf(false);
      setShowConfirmationAD(false);
      setUnitData([...unitData]);
    } else {
      setIsLoadingConf(false);
      setShowConfirmationAD(false);
      setUnitData([...unitData]);
    }
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingUS}
        setShow={showUnit}
        callApi={callApi}
        buttonDown={buttonDownUnit}
        mainData={unitData}
        handleChanged={handleChanged}
        addBtnClicked={addUnits}
        deletPressed={handleDelete}
        onSave={saveUnits}
        isDesabled={isUM}
        title={t('UNITS_MASTER.TITLE')}
        inputName={t('UNITS_MASTER.INPUT_NAME')}
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={umBtnDisable}
        isUnique={isUnitUnique}
        isUniqueId={isUniqUnitId}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('UNITS_MASTER.DELETE_CONFIRMATION_TITLE')}
          message={t('UNITS_MASTER.DELETE_CONFIRMATION_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('UNITS_MASTER.ACTIVE_INACTIVE_CONFIRMATION_TITLE')}
          message={t('UNITS_MASTER.ACTIVE_INACTIVE_CONFIRMATION_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default UnitsMaster;
